import api from 'services/api'

/**
 * @deprecated This service/type is deprecated and should not be used in new features
 * Use the new services/types from `services/shared/customers`
 */
export const getClientCredit = async (cd_clie: string) => {
  return await api
    .get(`/cliente/v2/CreditoClienteByID?cd_clie=${cd_clie}`)
    .then((response) => response.data)
    .catch((error) => {
      console.error(error)
    })
}
